import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./SendVerificationPage.css";

const SendVerificationPage = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(""); // To hold any error messages from the API
  const navigate = useNavigate();

  const handleSendVerification = async () => {
    if (!email) {
      toast.error("Please enter your email.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Invalid email format.");
      return;
    }

    setIsLoading(true);
    setError(""); // Clear previous errors
    try {
      const response = await fetch(
        process.env.REACT_APP_SEND_VERIFICATION_EMAIL,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, action: "send_verification" }), // Include the action parameter
        }
      );

      const data = await response.json();

      if (data.status === "success") {
        toast.success("Verification email sent successfully!");
        setTimeout(() => navigate("/Auth/login"), 2000); // Redirect after 2 seconds
      } else {
        setError(data.message || "Failed to send verification email.");
        toast.error(data.message || "Failed to send verification email.");
      }
    } catch (error) {
      setError("Error: " + error.message);
      toast.error("Error: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="verification-page">
      <h1>Send Verification Email</h1>
      <p>Please enter your email address to receive a verification link.</p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSendVerification();
        }}
      >
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          aria-describedby="error-message"
        />
        {error && (
          <span id="error-message" role="alert">
            {error}
          </span>
        )}
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Sending..." : "Send Verification Email"}
        </button>
      </form>
    </div>
  );
};

export default SendVerificationPage;
